import DelegateObjectTypeView from "../DelegateObjectTypeView.js";
export default DelegateObjectTypeView.create('SortModel');